import {Component} from '@angular/core';
import {Role} from '../../model/auth/Role';
import {MobileAwareComponent} from '../../common/mobile-aware/mobile-aware.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Contest} from '../../model/contest/Contest';
import {NotificationHandler} from '../../helper/notification.handler';
import {ContestService} from '../../service/contest.service';
import {MatDialog} from '@angular/material/dialog';
import {LocalStorageService} from 'ngx-webstorage';
import {CompetitionService} from '../../service/competition.service';
import {Competition} from '../../model/competition/Competition';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-contests-available-list',
  templateUrl: './contests-available-list.component.html',
  styleUrls: ['./contests-available-list.component.scss']
})
export class ContestsAvailableListComponent extends MobileAwareComponent {

  readonly roles = [Role.Admin, Role.Participant];

  competitions!: Competition[] | null;
  contests: Map<string, Contest[]> = new Map<string, Contest[]>();

  editAllowed = true;

  constructor(private contestService: ContestService,
              private competitionService: CompetitionService,
              private localStorageService: LocalStorageService,
              private dialog: MatDialog,
              breakpointObserver: BreakpointObserver) {
    super(breakpointObserver);
  }

  initContent() {
    this.loadCompetitions();
  }

  private loadCompetitions() {
    this.competitions = null;

    this.competitionService.getCompetitions(true).subscribe(competitions => {
      this.competitions = (competitions || []).filter(competition => !!competition.domain);

      this.competitions.forEach(competition => this.loadContests(competition.id));
    }, error => NotificationHandler.handleError($localize`:Notifications|Competitions fetch has failed message@@notifications-competitions-fetch-failed-error:Competitions fetch has failed`, error));
  }

  loadContests(competitionId: string) {
    this.contests.delete(competitionId);

    this.contestService.getOpenForEnrolContests(competitionId).subscribe(contests => {
      this.contests.set(competitionId, contests || []);
      if (contests && contests.length > 0) {
        this.contestService.getContests(competitionId).subscribe(pastContests => {
          if (pastContests && pastContests.length > 0) {
            const c = this.contests.get(competitionId) as Contest[];
            if (c) {
              c.forEach(contest => {
                const foundContest = pastContests.find(pastContest => pastContest.id == contest.id);
                if (foundContest) contest.paymentAt = foundContest.paymentAt;
              });
            }
          }
        }, error => NotificationHandler.handleError($localize`:Notifications|Contests fetch has failed message@@notifications-contests-fetch-failed-error:Contests fetch has failed`, error));
      }
    }, error => NotificationHandler.handleError($localize`:Notifications|Contests fetch has failed message@@notifications-contests-fetch-failed-error:Contests fetch has failed`, error));
  }

  getContests(competitionId: string): Contest[] {
    return this.contests.has(competitionId)
      ? this.contests.get(competitionId) || []
      : [];
  }

  navigateToCompetition(competition: Competition) {
    const url = `https://${competition.domain ? competition.domain + '.' : ''}${environment.ui.host}`;
    window.open(url, '_self');
  }
}
